import BasicContentComplexStat from './BasicContentComplexStat';

export { type BasicContentComplexStatProps } from './BasicContentComplexStat';
export default BasicContentComplexStat;
